export const DeliveryTimeFrameType = {
  DeliveryTimeFrame: 'DELIVERY_TIME_FRAME',
  LastOrderByDate: 'LAST_ORDER_BY_DATE',
} as const;

export interface DeliveryTimeFrame {
  type: typeof DeliveryTimeFrameType.DeliveryTimeFrame;
  earliest: string;
  latest: string;
}

export interface LastOrderByDate {
  type: typeof DeliveryTimeFrameType.LastOrderByDate;
  daysLeft: number;
  targetDate: string;
}

export type DeliveryDatesDetail = DeliveryTimeFrame | LastOrderByDate;

export interface DeliveryDatesApiResponse {
  standard: DeliveryDatesDetail;
  express?: DeliveryDatesDetail;
}

export type DeliveryDatesFetchState =
  | 'delivery-dates-fetch'
  | 'delivery-dates-refetch';
